<template>
  <div v-if="yieldsForDate" class="panel">
    <div class="row">
      <div class="col-sm-7">
        <span class="the-number"><CalloutValue :text="callout" :bpsChange="bpsChange"/></span><br>
        {{durationLabel}} yield as of <formatted-date :date="currentDate"/>
      </div>
      <div class="col-sm-5 callout">
        <div><span>{{bpsCallout}}</span> bps</div>
        <div>% change: <span>{{percentageChangeCallout}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as data from '../../../client/src/data.js';
  import CalloutValue from './CalloutValue';
  import FormattedDate from './FormattedDate';
  export default {
    components: {CalloutValue, FormattedDate},
    props: {
      yieldsForDate: {
        required: true
      },
      currentDate: {
        required: true
      },
      durationInMonths: {
        required: true
      }
    },
    computed: {
      durationLabel() {
        return data.LONG_DURATION_LABELS.find(element => element[0] === this.durationInMonths)[1];
      },
      yieldsForDurationAndDate() {
        return this.yieldsForDate[data.getDurationIndexFromMonths(this.durationInMonths)];
      },
      callout() {
        return this.yieldsForDate && data.isNumber(this.yieldsForDurationAndDate[0]) ? this.yieldsForDurationAndDate[0].toFixed(2) + '%' : '';
      },
      bpsChange() {
        return this.yieldsForDurationAndDate[1];
      },
      bpsCallout() {
        return this.yieldsForDate && data.isNumber(this.bpsChange) ? (this.bpsChange * 100).toFixed(0) : '';
      },
      percentageChangeCallout() {
        return this.yieldsForDate && data.isNumber(this.yieldsForDurationAndDate[2]) ? (this.yieldsForDurationAndDate[2]).toFixed(2) + '%' : '';
      },
    }
  }
</script>

